import {IbanTercihiEnum} from "../uyap/IbanTercihiEnum";
import {OdemeTipiEnum} from "@/plugins/uyap-plugin/takip_ac/OdemeTipleri";

export class MtsDosyaFormData {
    //MTS
    ibanTercihi: IbanTercihiEnum = IbanTercihiEnum.Avukat;
    avukatIban: string = "";
    il: string = "";
    xml: any;
    adliye: string = "";
    alacakliEposta: string = "";
    alacakliTelefon: string = "";
    alacakliMernisAdresiKullan: boolean = false;
    mernisAdresiKullan: boolean = false;
    odemeYapilmasin: boolean = false;
    mahiyetId!: number;
    terekemi: boolean = false;
    birimAd: string = "";
    alacakliTaraf: any = {};
    odemeTipi: OdemeTipiEnum = OdemeTipiEnum.Ebarobirlikkart;

}